<ng-container *ngIf="rowCells.length > 0">
    <div class="editor-header">
        <nb-actions size="small">
            <nb-action (click)="goBack($event)">
                <nb-icon icon="arrow-back-outline" pack="eva" title="Back"></nb-icon>Back
            </nb-action>
        </nb-actions>
        <div>Edit Cells - {{selectedSection?.sectionId}}</div>
    </div>
    <div *ngFor="let cell of rowCells;let i=index" class="section-thumbnail input-cell">
        <div class="thumbnail-img">
            <img src="{{cell.imgSrc}}">
        </div>
        <div class="edit-options">
            <nb-actions size="small">
                <nb-action (click)="open({action:'image',imgSrc:cell.imgSrc,cellId:cell.cellId})">
                    <nb-icon icon="image-outline" pack="eva" title="Edit Image"></nb-icon>Image - {{cell.cellId}}
                </nb-action>
                <nb-action (click)="open({action:'header',imgSrc:cell.imgSrc})">
                    <nb-icon icon="browser-outline" pack="eva" title="Edit Header"></nb-icon>
                    Header</nb-action>
                <nb-action (click)="open({action:'footer',imgSrc:cell.imgSrc})">
                    <nb-icon icon="book-outline" pack="eva" title="Edit Footer"></nb-icon>Footer</nb-action>
                <nb-action (click)="open({action:'link',imgSrc:cell.imgSrc})">
                    <nb-icon icon="link-2-outline" pack="eva" title="Edit Link"></nb-icon>Link</nb-action>
            </nb-actions>
        </div>
    </div> 
</ng-container>

